module.exports = {
  src: __webpack_public_path__ + "assets/images/download-icon.6ee3702329eb4dab.svg",
  width: 23,
  height: 22,
  toString: function() { return __webpack_public_path__ + "assets/images/download-icon.6ee3702329eb4dab.svg"; }
};